// @flow
import * as React from 'react';
import Experience from 'app/common/react/components/experiences/Experience/Experience';
import NuxContainer from 'app/common/react/components/growth/activation/NuxContainer/NuxContainer';
import toCamelCase from 'app/common/lib/util/toCamelCase';
import { deepMapStringKeys } from 'app/common/lib/util/ObjectUtils';

type ExperienceNuxContainerProps = { placementId: number };

const ExperienceNuxContainer = ({ placementId, ...props }: ExperienceNuxContainerProps) => (
  <Experience placementId={placementId} type={PCONST.thrift.ExperienceType.NUX}>
    {({ complete, dismiss, display_data }) => (
      <NuxContainer
        {...deepMapStringKeys(toCamelCase, true)(display_data)}
        handleComplete={complete}
        handleDismiss={dismiss}
        {...props}
      />
    )}
  </Experience>
);

export default ExperienceNuxContainer;
